import * as React from 'react';
import ResetPassword from '../ResetPassword';

class SetPassword extends React.Component {
    public render() {
        return (
            <ResetPassword
                {...this.props}
                content={'Please note, your details here are specific to Travel Insurance and separate to ' +
                'your My Account details that you use for Motor / Household.'}
                title={'Set Password'}
                message={'Your password has been set, please login to access your account.'}
            />
        );
    }
}

export default SetPassword;
